import React from 'react';
import { Tooltip } from 'antd';

export const CommonTooltip = ({ title, children, mouseEnterDelay = 1, mouseLeaveDelay = 0 }) => (
  <Tooltip placement="bottom" mouseEnterDelay={mouseEnterDelay} mouseLeaveDelay={mouseLeaveDelay} title={title}>
    {children}
  </Tooltip>
);
